import { CatalogoModel } from "./bin-catalogos.model";

export class ListaCatalogosModel{
    public lstCatAccionEstat:Array<CatalogoModel>;
    public lstCatBancos:Array<CatalogoModel>;
    public lstCatBancosProsa:Array<CatalogoModel>;
    public lstCatBinEstat:Array<CatalogoModel>;
    public lstCatEGlobalBancos:Array<CatalogoModel>;
    public lstCatProdu:Array<CatalogoModel>;
    public lstCatTipoBines:Array<CatalogoModel>;
    constructor(){
        this.lstCatAccionEstat = new Array<CatalogoModel>();
        this.lstCatBancos = new Array<CatalogoModel>();
        this.lstCatBancosProsa = new Array<CatalogoModel>();
        this.lstCatBinEstat = new Array<CatalogoModel>();
        this.lstCatEGlobalBancos = new Array<CatalogoModel>();
        this.lstCatProdu = new Array<CatalogoModel>();
        this.lstCatTipoBines = new Array<CatalogoModel>();
    }
}